import { PRIZES_IMAGES } from 'containers/Login/constants'

function Prizes() {
  return (
    <div className="awards-container">
      {PRIZES_IMAGES.map((image) => (
        <a
          href="https://ironscales.com/company/news-awards/awards"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={`${STATIC_BASE_URL}/static/webapp/images/login/${image}.png`} />
        </a>
      ))}
    </div>
  )
}

export default Prizes
